import { render, staticRenderFns } from "./UserListAddNew.vue?vue&type=template&id=6c400564&"
import script from "./UserListAddNew.vue?vue&type=script&lang=js&"
export * from "./UserListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./UserListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports